// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"116": "3c4f3134","315": "56950cc5","396": "26ebd4a5","525": "e728018f","75": "723c97d1","82": "65c55dbf",}[chunkId] + ".js"
}